module.exports = __webpack_public_path__ + "static/media/yearend.8d811ab9.png";